module.exports = __webpack_public_path__ + "static/media/black-cat-lose.40ec27f9.png";